import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { ViewApi } from '@/lib/api/roadmapping/view';
import { viewQueryKeys } from '@/lib/query-keys/view';

/**
 * Query options factory for fetching all views.
 */
export const getViewsQueryOptions = (roadmapId: number) =>
  queryOptions({
    queryKey: viewQueryKeys.view.list(roadmapId),
    queryFn: () => ViewApi.fetchViews(roadmapId),
  });

/**
 * Query options factory for fetching a single view by ID.
 */
export const getViewQueryOptions = (viewId: number) =>
  queryOptions({
    queryKey: viewQueryKeys.view.details(viewId),
    queryFn: () => ViewApi.fetchView(viewId),
  });

export const useViews = (roadmapId: number) => useQuery(getViewsQueryOptions(roadmapId));

export const useViewsData = (roadmapId: number) =>
  useSuspenseQuery(getViewsQueryOptions(roadmapId));

export const useView = (id: number) => {
  return useQuery({
    ...getViewQueryOptions(id),
    enabled: !!id,
  });
};

export const useViewData = (id: number) => {
  return useSuspenseQuery(getViewQueryOptions(id));
};
